import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Header from "./components/common/Header";
import PageNotFound from "./components/PageNotFound";
import ProfilePage from "./components/user/ProfilePage";
import CompanyList from "./components/company/CompanyList";
import CompanyDetail from "./components/company/CompanyDetail";
import NewCompany from "./components/company/NewCompany";
import SignIn from "./components/authentication/SignIn";
import PrivateRoute from "./components/common/PrivateRoute";
import SignOut from "./components/authentication/SignOut";
import ForgotPassword from "./components/authentication/ForgotPassword";
import Message from "./components/authentication/Message";
import PremiumListAdmin from "./components/premium/PremiumListAdmin";
import UserList from "./components/user/UserList";
import UserDetail from "./components/user/UserDetail";
import NewUser from "./components/user/NewUser";
import PremiumDetailAdmin from "./components/premium/PremiumDetailAdmin";
import NewPremiumAdmin from "./components/premium/NewPremiumAdmin";
import ImportTFFData from "./components/premium/ImportTFFData";
import VintageListAdmin from "./components/premium/VintageListAdmin";
import VintageByYearAdmin from "./components/premium/VintageByYearAdmin";
import ClearingListAdmin from "./components/clearing/ClearingListAdmin";
import ClearingDetailsAdmin from "./components/clearing/ClearingDetailsAdmin";
import ClearingDetailsUser from "./components/clearing/ClearingDetailsUser";
import StatusReport from "./components/report/StatusReport";
import PrizeReport from "./components/report/PrizeReport";
import CasesStatus from "./components/report/CasesStatus";
import AccumulatedDataimport from "./components/report/AccumulatedDataimport";
import IBNRdata from "./components/report/IBNRdata";
import PrizeShare from "./components/report/PrizeShare";
import YFFEconomyContacts from "./components/report/YFFEconomyContacts";
import NAVContacts from "./components/report/NAVContacts";
import DataImport from "./components/data/DataImport";
import ValidateDataImportResult from "./components/data/ValidateDataImportResult";
import CapitalCall from "./components/data/CapitalCall";
import Income from "./components/data/Income";
import Cost from "./components/data/Cost";
import IBNR from "./components/data/IBNR";
import PremiumListUser from "./components/premium/PremiumListUser";
import PremiumDetailUser from "./components/premium/PremiumDetailUser";
import NewPremiumUser from "./components/premium/NewPremiumUser";
import VintageListUser from "./components/premium/VintageListUser";
import VintageByYearUser from "./components/premium/VintageByYearUser";
import GKImport from "./components/gk/GKImport";
import ImportList from "./components/gk/ImportList";
import ImportDetail from "./components/gk/ImportDetail";
import GKQuarters from "./components/gk/GKQuarters";
import GKCountry from "./components/gk/GKCountry";
import ClearingListUser from "./components/clearing/ClearingListUser";
import ViewLogs from "./components/logging/ViewLogs";

export const Role = {
  Admin: "Admin",
  FNO: "FNO",
  TFF: "TFF",
  YFF: "YFF",
  GK: "GK",
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#3F51B5",
      dark: "#303F9F",
      contrastText: "#FFFFFF",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

class App extends React.Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <div style={{ display: "flex" }}>
          <Header theme={theme} />

          <Routes>
            <Route
              path="/"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin, Role.TFF, Role.YFF, Role.GK]}><CompanyDetail /></PrivateRoute>}
            />

            <Route
              path="/profile"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin, Role.TFF, Role.YFF, Role.GK]}><ProfilePage /></PrivateRoute>}
            />

            {/* COMPANY ROUTES */}
            <Route
              path="/companylist"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><CompanyList /></PrivateRoute>}
            />
            <Route
              path="/companydetail/:id"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><CompanyDetail /></PrivateRoute>}
            />
            <Route
              path="/newcompany"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><NewCompany /></PrivateRoute>}
            />

            {/* USER ROUTES */}
            <Route path="/userlist"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><UserList /></PrivateRoute>}
            />
            <Route path="/userdetail/:username"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><UserDetail /></PrivateRoute>}
            />
            <Route path="/newuser"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><NewUser /></PrivateRoute>}
            />

            {/* ADMIN PREMIUM ACTIONS */}
            <Route
              path="/premiumlistadmin"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><PremiumListAdmin /></PrivateRoute>}
            />
            <Route
              path="/premiumdetailadmin/:org/:companyId/:year"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><PremiumDetailAdmin /></PrivateRoute>}
            />
            <Route
              path="/newpremiumadmin"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><NewPremiumAdmin /></PrivateRoute>}
            />
            <Route
              path="/importtffdata"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><ImportTFFData /></PrivateRoute>}
            />
            <Route
              path="/policyyearlistadmin"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><VintageListAdmin /></PrivateRoute>}
            />
            <Route
              path="/policyyearadmin/:org/:year"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><VintageByYearAdmin /></PrivateRoute>}
            />


            {/* TFF PREMIUM ACTIONS */}
            <Route
              path="/premiumlisttff"
              element={<PrivateRoute roles={[Role.TFF]}><PremiumListUser type="TFF" /></PrivateRoute>}
            />
            <Route
              path="/newpremiumtff"
              element={<PrivateRoute roles={[Role.TFF]}><NewPremiumUser type="TFF" /></PrivateRoute>}
            />
            <Route
              path="/lastpremiumtff"
              element={<PrivateRoute roles={[Role.TFF]}><PremiumDetailUser type="TFF" /></PrivateRoute>}
            />
            <Route
              path="/premiumdetailtff/:year"
              element={<PrivateRoute roles={[Role.TFF]}><PremiumDetailUser type="TFF" /></PrivateRoute>}
            />
            <Route
              path="/policyyearlisttff"
              element={<PrivateRoute roles={[Role.TFF]}><VintageListUser type="TFF" /></PrivateRoute>}
            />
            <Route
              path="/policyyeartff/:year"
              element={<PrivateRoute roles={[Role.TFF]}><VintageByYearUser type="TFF" /></PrivateRoute>}
            />

            {/* YFF PREMIUM ACTIONS */}
            <Route
              path="/premiumlistyff"
              element={<PrivateRoute roles={[Role.YFF]}><PremiumListUser type="YFF" /></PrivateRoute>}
            />
            <Route
              path="/newpremiumyff"
              element={<PrivateRoute roles={[Role.YFF]}><NewPremiumUser type="YFF" /></PrivateRoute>}
            />
            <Route
              path="/lastpremiumyff"
              element={<PrivateRoute roles={[Role.YFF]}><PremiumDetailUser type="YFF" /></PrivateRoute>}
            />
            <Route
              path="/premiumdetailyff/:year"
              element={<PrivateRoute roles={[Role.YFF]}><PremiumDetailUser type="YFF" /></PrivateRoute>}
            />
            <Route
              path="/policyyearlistyff"
              element={<PrivateRoute roles={[Role.YFF]}><VintageListUser type="YFF" /></PrivateRoute>}
            />
            <Route
              path="/policyyearyff/:year"
              element={<PrivateRoute roles={[Role.YFF]}><VintageByYearUser type="YFF" /></PrivateRoute>}
            />


            {/* ADMIN CLEARING ACTIONS */}
            <Route
              path="/clearinglistadmin"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><ClearingListAdmin /></PrivateRoute>}
            />
            <Route
              path="/clearingdetailsadmin/:id"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><ClearingDetailsAdmin /></PrivateRoute>}
            />

            {/* TFF CLEARING ACTIONS */}
            <Route
              path="/clearinglistTFF"
              element={<PrivateRoute roles={[Role.TFF]}><ClearingListUser type="TFF" /></PrivateRoute>}
            />
            <Route
              path="/clearingdetailsTFF/:id"
              element={<PrivateRoute roles={[Role.TFF]}><ClearingDetailsUser type="TFF" /></PrivateRoute>}
            />
            <Route
              path="/lastclearingTFF"
              element={<PrivateRoute roles={[Role.TFF]}><ClearingDetailsUser type="TFF" /></PrivateRoute>}
            />
            {/* YFF CLEARING ACTIONS */}
            <Route
              path="/clearinglistYFF"
              element={<PrivateRoute roles={[Role.YFF]}><ClearingListUser type="YFF" /></PrivateRoute>}
            />
            <Route
              path="/clearingdetailsYFF/:id"
              element={<PrivateRoute roles={[Role.YFF]}><ClearingDetailsUser type="YFF" /></PrivateRoute>}
            />
            <Route
              path="/lastclearingYFF"
              element={<PrivateRoute roles={[Role.YFF]}><ClearingDetailsUser type="YFF" /></PrivateRoute>}
            />


            {/* REPORT ROUTES */}
            <Route
              path="/statusreport"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><StatusReport /></PrivateRoute>}
            />
            <Route
              path="/premiumreport"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><PrizeReport /></PrivateRoute>}
            />
            <Route
              path="/casesstatus"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><CasesStatus /></PrivateRoute>}
            />
            <Route
              path="/accumulateddataimport"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><AccumulatedDataimport /></PrivateRoute>}
            />
            <Route
              path="/ibnrdata"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><IBNRdata /></PrivateRoute>}
            />
            <Route
              path="/premiumshare"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><PrizeShare /></PrivateRoute>}
            />
            <Route
              path="/yffeconomycontacts"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><YFFEconomyContacts /></PrivateRoute>}
            />
            <Route
              path="/navcontacts"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><NAVContacts /></PrivateRoute>}
            />

            {/* DATA ROUTES */}
            <Route
              path="/dataimport"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><DataImport /></PrivateRoute>}
            />
            <Route
              path="/validatedataimportresult"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><ValidateDataImportResult /></PrivateRoute>}
            />
            <Route
              path="/datacaptialcall"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><CapitalCall /></PrivateRoute>}
            />
            <Route
              path="/dataincome"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><Income /></PrivateRoute>}
            />
            <Route
              path="/datacost"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><Cost /></PrivateRoute>}
            />
            <Route
              path="/dataibnr"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><IBNR /></PrivateRoute>}
            />

            {/* GK ROUTES */}
            <Route
              path="/gkimport"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin, Role.GK]}><GKImport /></PrivateRoute>}
            />
            <Route
              path="/gkimportlist"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin, Role.GK]}><ImportList /></PrivateRoute>}
            />
            <Route
              path="/gkimportdetail/:id/:year/:quarter"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin, Role.GK]}><ImportDetail /></PrivateRoute>}
            />
            <Route
              path="/gkquarters"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin, Role.GK]}><GKQuarters /></PrivateRoute>}
            />
            <Route
              path="/gkcountry"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin, Role.GK]}><GKCountry /></PrivateRoute>}
            />

            {/* AUTH ROUTES */}
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signout" element={<SignOut />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/message" element={<Message />} />

            {/* Logging for developers */}
            <Route
              path="/log"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin]}><ViewLogs /></PrivateRoute>}
            />

            {/* CATCH-ALL ROUTE */}
            <Route
              path="*"
              element={<PrivateRoute roles={[Role.FNO, Role.Admin, Role.TFF, Role.YFF, Role.GK]}><PageNotFound /></PrivateRoute>}
            />
          </Routes>

          <ToastContainer autoClose={2500} hideProgressBar />
        </div>
      </ThemeProvider>
    );
  }
}

export default (App);
